import { render, staticRenderFns } from "./NextcloudUser.vue?vue&type=template&id=bb4eef48&scoped=true&"
import script from "./NextcloudUser.vue?vue&type=script&lang=js&"
export * from "./NextcloudUser.vue?vue&type=script&lang=js&"
import style0 from "./NextcloudUser.vue?vue&type=style&index=0&id=bb4eef48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4eef48",
  null
  
)

export default component.exports